import { css } from '@emotion/react'
import { eerieBlack } from '../../style/colors'

export const styleHoverIcon = css`
  :hover > div > div {
    background-color: ${eerieBlack['800']};
  }
`
